import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { AnimatePresence } from "framer-motion"

import { Animation } from 'components'
import { FaCheck } from 'react-icons/fa';

const Container = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin: ${props => props.margin || '0.3rem 0 0 0'};
    padding: 0.2rem 0;
    cursor: ${props => !props.disabled && 'pointer'};
`

const Checkbox = styled.div`
    color: ${props => props.color || 'white'};
    background-color: ${props => props.backgroundColor || 'transparent'};
    border-color: ${props => props.borderColor || 'var(--secondary-accent-color)'};
    border-radius: 50%;
    /* border-radius: 5px; */
    border-width: 2px;
    border-style: solid;
    width: 1rem;
    height: 1rem;
    font-size: 0.4rem;
    display: flex;
    justify-content: center;
    align-items: center;
`

const Check = (props) => {
    const {
        backgroundColor,
        borderColor,
        color,
        filled,
        onSelect,
        disabled,
        margin
    } = props;

    const [hover, setHover] = useState(false);
    return (
        <AnimatePresence initial={false}>
            <Animation animation='default'>
                <Container onClick={() => !disabled && onSelect()} onMouseEnter={() => setHover(!hover)} onMouseLeave={() => setHover(!hover)} 
                    disabled={disabled} margin={margin}>
                    <Checkbox {...props}>
                        {filled || hover ? <FaCheck/> : null}
                    </Checkbox>
                </Container>
            </Animation>
        </AnimatePresence>
        
    )
}

export default Check;

Check.propTypes = {
    backgroundColor: PropTypes.string,
    borderColor: PropTypes.string,
    color: PropTypes.string,
    filled: PropTypes.bool,
    onSelect: PropTypes.func.isRequired,
}